<app-esqueleto-tableros>
  <div titulo class="encabezadosSeparacion">
    <span class="headerCintilla1">{{ "menu." + dataService.moduleSelect | translate }}</span>
    <span class="bullSeparation">&bull;</span>
    <span class="headerCintilla2">{{ "menu." + dataService.subModuleSelect | translate }}</span>
  </div>
  <!-- FILTROS -->
  <app-filters filtros
    [name]="'filtros.anio' | translate"
    [array]="aniosDisponibles"
    [typeFilter]="Filters.YEAR"
    (eventClick)="anioChangeListener($event)"
    [click]="false">
  </app-filters>
  <app-filters filtros
    [name]="'filtros.mes' | translate"
    [array]="mesesDeAnioDisponibles"
    [typeFilter]="Filters.MOUNTH"
    (eventClick)="mesChangeListener($event, mesesDeAnioDisponibles)"
    [click]="false">
  </app-filters>
  <app-filters filtros
    [name]="'filtros.perdida' | translate"
    [array]="filtroPerdidas"
    [typeFilter]="Filters.SUCURSALES"
    [consolidado]="todas_perdidas"
    (eventClick)="consolidadoChangeListener($event)">
  </app-filters>
  <div borrador>
    <div class="w3-button w3-dropdown-click" style="transform: scale(0.9);" [ngStyle]="{'color':'gray'}"
      matTooltip="{{'tooltips.borrar-filtros'|translate}}" (click)="quitarFiltros()">
      <img src="./../../../../assets/img/eraser.png">
    </div>
  </div>
   <!-- CONTENIDO -->
  <div contenido class="zonaContenido">
    <app-contenedor-elementos class="zona1"  id="Zona1"
      [header]="{title: 'menu.'+dataService.subModuleSelect | translate, subtitles: [ {text:subtituloGrafica}]}">
      @if(!mostrarTabla){
        <mat-icon iconos class="iconoMen margenDer" fontSet="material-icons-outlined" [ngStyle]="{'color':'gray'}" 
          (click)="showLabels = !showLabels"  matTooltip="{{'financiero.razonesFinancieras.tooltipIcono0'|translate}}">
          {{showLabels ? 'label_off' : 'label'}}
        </mat-icon>            
      }            
      <mat-icon iconos class="iconoMen" [ngStyle]="{'color':'gray'}" 
        (click)="AmpliarGraficaC1(mostrarTabla ? 2 : 1)">
        zoom_out_map
      </mat-icon>  
      <mat-icon iconos [ngStyle]="{'color':'gray'}" [matMenuTriggerFor]="menu">
        more_vert
      </mat-icon>
      <mat-menu #menu="matMenu">
        <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" [matMenuTriggerFor]="graficas">
          <mat-icon [ngStyle]="{'color':'gray'}">assessment</mat-icon>
          <span>{{'menu.graficas' | translate}}</span>
        </button>
        @if (perspectiva) {
          <div class="mat-menu-item w3-caja-menu" mat-menu-item [matMenuTriggerFor]="menu.perspectivas" #trigger="matMenuTrigger">
            <mat-icon [ngStyle]="{'color':'gray'}">account_tree</mat-icon>
            <span style="color: black;">{{'filtros.pers' | translate}}</span>
          </div>
          <app-menu-perspectivas #menu 
                    [tipo]="submenus" 
                    [tablero]="'tendencia'"
                    (eventClick)="filterChange($event);">
          </app-menu-perspectivas>        
        }
        <mat-divider></mat-divider>
        <button mat-menu-item (click)="!mostrarTabla ? export_img(1) : export_csv(2)">
          <mat-icon [ngStyle]="{'color':'gray'}">{{!mostrarTabla ? 'image' : 'description'}}</mat-icon>
          <span>{{'menu.Exportar' | translate}}</span>
        </button>
      </mat-menu>
      <mat-menu #graficas="matMenu">
        <button mat-menu-item (click)="mostrarTabla = true;" [ngClass]="{'w3-disabled': mostrarTabla}" [disabled]="mostrarTabla">
        <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">table_chart</mat-icon>
        <span>{{'graf.tabla' | translate}}</span>
      </button><button mat-menu-item (click)="tipoSelec = tipoGraf.AREA; mostrarTabla = false;" 
          [ngClass]="{'w3-disabled': tipoSelec == tipoGraf.AREA && !mostrarTabla}" [disabled]="tipoSelec == tipoGraf.AREA && !mostrarTabla">
          <mat-icon [ngStyle]="{'color':'gray'}">area_chart</mat-icon>
          <span>{{'graf.area' | translate}}</span>
        </button>
        <button mat-menu-item (click)="tipoSelec = tipoGraf.LINE; mostrarTabla = false;" 
          [ngClass]="{'w3-disabled': tipoSelec == tipoGraf.LINE && !mostrarTabla}" [disabled]="tipoSelec == tipoGraf.LINE && !mostrarTabla">
          <mat-icon [ngStyle]="{'color':'gray'}">show_chart</mat-icon>
          <span>{{'graf.lineal' | translate}}</span>
        </button>
      </mat-menu>
      <div body style="height: 100%;">
        @if (multi.length !== 0) {
          @if(!mostrarTabla){
            <app-graficador 
              [etiquetas]="showLabels"
              [data]="multi"
              [labels]="etiquetas"
              [type]="tipoSelec"
              [axisX]="xAxisLabel"
              [axisY]="yAxisLabel"
              [zona]="1"
              [colors]="colorScheme"
              [formatEtiquetas]="true"
              [changeLabel]="changeLabel"
              [legend]="{enabled: true, position: 'bottom'}"
              (eventClick)="onSelect($event)"
            ></app-graficador>  
          }@else {
            <div class="w3-encabezado-table w3-scroll" >
              <div class="w3-table-all">
                <table class="tabla-aleema">
                  <thead>
                    <tr>
                      <th>{{'riesgo-credito.tendencia.tit1' | translate}}</th>
                      <th>{{'riesgo-credito.tendencia.tit2' | translate}}</th>
                      <th>{{'riesgo-credito.tendencia.tit3' | translate}}</th>
                      <th>{{'riesgo-credito.tendencia.var' | translate}}</th>
                    </tr>
                  </thead>   
                  @for (element of dataSource; track $index) {
                    <tbody>
                      <tr class="w3-center">
                        <td> {{element.periodo}}</td>
                        <td> {{element.perdidaesperada | formaterNumber:0:miles:decimal}}</td>
                        <td> {{element.perdidanoesperada | formaterNumber:0:miles:decimal}}</td>
                        <td> {{element.var90 | formaterNumber:0:miles:decimal}}</td>
                      </tr>
                    </tbody>
                  }
                </table>
              </div>
            </div>
          }            
        }@else {<app-skeleton-grafica />}    
      </div>
    </app-contenedor-elementos>
    <div class="zona2">
      <app-contenedor-elementos class="zonaTabla" [header]="{title: 'riesgo-credito.tendencia.titulo' | translate, 
        subtitles: [ {text:subtituloGraficaTabla}]}">
        <mat-icon iconos class="iconoMen margenDer" [ngStyle]="{'color':'gray'}" (click)="AmpliarGraficaC1(3)">zoom_out_map</mat-icon>
        <mat-icon iconos [matMenuTriggerFor]="menu_tabla" [ngStyle]="{'color':'gray'}">more_vert</mat-icon>
        <mat-menu #menu_tabla="matMenu">
          <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" [matMenuTriggerFor]="menuPeriodos">
            <mat-icon [ngStyle]="{'color':'gray'}">calendar_month</mat-icon>
            <span> {{'menu.per' | translate}}</span>
          </button>
          <mat-divider></mat-divider>
          <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" (click)="export_csv(3)">
            <mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
            <span> {{'menu.exportar' | translate}}</span>
          </button>
        </mat-menu>
        <mat-menu #menuPeriodos="matMenu">
          @for (per of periodosExp; track $index) {
            <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" (click)="cambiarPeriodoExp(per)"
              [ngClass]="{'w3-disabled': per.check}" [disabled]="per.check">
              <span> {{per.name}}</span>
            </button>
          }
        </mat-menu>
        <div body class="w3-scroll" style="height: 100%;">
          @if(dataExp.length !== 0){
            <div class="w3-table-all">
              <table class="tabla-aleema">
                <thead>
                  <tr>
                    <th>{{'riesgo-credito.tendencia.tit4' | translate}}</th>                    
                    <th>{{'riesgo-credito.tendencia.tit5' | translate}}</th>                    
                    <th>{{'riesgo-credito.tendencia.tit6' | translate}}</th>                    
                    <th>{{'riesgo-credito.tendencia.tit2' | translate}}</th>                    
                  </tr>
                </thead>   
                  <tbody>
                    @for (d of dataExp; track d; let i = $index) {
                      <tr class="w3-center">
                        <td class="w3-table-titleLow">{{d.nombre}}</td>
                        <td>{{d.saldo | formaterNumber:0:miles:decimal}}</td>                      
                        <td>{{d.prob | formaterNumber:2:miles:decimal}} %</td>                      
                        <td>{{d.perdida | formaterNumber:0:miles:decimal}}</td>                      
                      </tr>
                    }
                  </tbody>
              </table>
            </div>
          }@else {<app-skeleton-table [columnas]="4" [filas]="6"/>}
        </div>
      </app-contenedor-elementos>
      <div class="zonaTarjetas">
        <div class="tarjeta">
          @if(suma_PerdidaEsperada){
            <app-tarjetas [header]="'riesgo-credito.tendencia.tit2' | translate" [valueStr]="suma_PerdidaEsperada | formaterNumber:0:miles:decimal" 
            [footer]="aniomesSeleccionado" [showIcon]="false" [iconFirst]="false" [color]="'#0070C0'"
            [alto]="'12.3vh'" [siceHeader]="'2.5vh'" [siceValue]="'3vh'" [siceFooter]="'2vh'" [sice]="'6vh'"/>
          }@else{<app-skeleton-card/>}
        </div>
        <div class="tarjeta">
          @if(suma_PerdidaNoEsperada95){
            <app-tarjetas [header]="'riesgo-credito.tendencia.tit3' | translate" [valueStr]="suma_PerdidaNoEsperada95 | formaterNumber:0:miles:decimal" 
            [footer]="aniomesSeleccionado" [showIcon]="false" [iconFirst]="false" [color]="'#0070C0'"
            [alto]="'12.3vh'" [siceHeader]="'2.5vh'" [siceValue]="'3vh'" [siceFooter]="'2vh'" [sice]="'6vh'"/>
          }@else{<app-skeleton-card/>}
        </div>
        <div class="tarjeta">
          @if(suma_VaR95){
            <app-tarjetas [header]="'riesgo-credito.tendencia.var' | translate" [valueStr]="suma_VaR95 | formaterNumber:0:miles:decimal" 
            [footer]="aniomesSeleccionado" [showIcon]="false" [iconFirst]="false" [color]="'#0070C0'"
            [alto]="'12.3vh'" [siceHeader]="'2.5vh'" [siceValue]="'3vh'" [siceFooter]="'2vh'" [sice]="'6vh'"/>
          }@else{<app-skeleton-card/>}
        </div>
      </div>
    </div>
  </div>
</app-esqueleto-tableros>

<app-modal [isOpen]="modalOpen" [export]="true" [iconoExport]="iconoExportar" [labels]="labelsModal" [labelsState]="showLabels"
  (changeLables)="showLabels = !showLabels" (exportFile)="exportarModal()" (close)="modalOpen = !modalOpen">
  <div modal-header>
    <span class="w3-margin-left-contenido">{{titulomodal}}</span>
    <span class="w3-punto-subtitulo w3-margin-left-filter" >&bull;</span>
    <span class=" w3-margin-left-filter w3-subtitulo">{{subtitulomodal}}</span>
  </div>
  <div modal-body style="max-height: 70vh; width: 70vw;" >
    <!-- <div class="w3-row"> -->
      <div class="w3-row w3-margin" style="height: 65vh;">
        @if (grafTablaModal === 1) {
          <app-graficador 
            [etiquetas]="showLabels"
            [data]="multi"
            [labels]="etiquetas"
            [type]="tipoSelec"
            [axisX]="xAxisLabel"
            [axisY]="yAxisLabel"
            [zona]="2"
            [colors]="colorScheme"
            [formatEtiquetas]="true"
            [changeLabel]="changeLabel"
            [legend]="{enabled: true, position: 'bottom'}"
          ></app-graficador> 
        }
        @if(grafTablaModal === 2) {
          <div class="w3-scroll" style="height: 90%;">
            <table class="tabla-aleema">
              <thead>
                <tr class="w3-center">
                  <th>{{'riesgo-credito.tendencia.tit1' | translate}}</th>
                  <th>{{'riesgo-credito.tendencia.tit2' | translate}}</th>
                  <th>{{'riesgo-credito.tendencia.tit3' | translate}}</th>
                  <th>{{'riesgo-credito.tendencia.var' | translate}}</th>
                </tr>
              </thead>   
              @for (element of dataSource; track $index) {
                <tbody>
                  <tr class="w3-center">
                    <td> {{element.periodo}}</td>
                    <td> {{element.perdidaesperada | formaterNumber:0:miles:decimal}}</td>
                    <td> {{element.perdidanoesperada | formaterNumber:0:miles:decimal}}</td>
                    <td> {{element.var90 | formaterNumber:0:miles:decimal}}</td>
                  </tr>
                </tbody>
              }
            </table>
          </div>          
        }   
        @if(grafTablaModal === 3){
          <div class="w3-scroll">
            <table class="tabla-aleema">
                <thead>
                  <tr class="w3-center">
                    <th>{{'riesgo-credito.tendencia.tit4' | translate}}</th>                    
                    <th>{{'riesgo-credito.tendencia.tit5' | translate}}</th>                    
                    <th>{{'riesgo-credito.tendencia.tit6' | translate}}</th>                    
                    <th>{{'riesgo-credito.tendencia.tit2' | translate}}</th>                    
                  </tr>
                </thead>   
                  <tbody>
                    @for (d of dataExp; track d; let i = $index) {
                      <tr class="w3-center">
                        <td class="w3-table-titleLow">{{d.nombre}}</td>
                        <td>{{d.saldo | formaterNumber:0:miles:decimal}}</td>                      
                        <td>{{d.prob | formaterNumber:2:miles:decimal}} %</td>                      
                        <td>{{d.perdida | formaterNumber:0:miles:decimal}}</td>                      
                      </tr>
                    }
                  </tbody>
              </table>
          </div>
        }         
      </div>
    <!-- </div> -->
  </div>
</app-modal>